import React from 'react';
import DisplayTemplate from '../displayTemplate';
import {getYouTubeVideoId} from '../../utils'

export default function YoutubeVideo({contentType, content, contentDisplayType, contentUrl, mediaStyle, overrideHTML, renderDefault = false, helpText, templateType, ...props}) {
    const videoId = getYouTubeVideoId(contentUrl);

    return (
		<div className="youtube-video">
			<iframe {...props}
                width="100%" 
                height="315" 
                src={"https://www.youtube.com/embed/" + videoId} title="YouTube video player" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
		</div>)
}